{
  "name": "@apfelkiste/critical.finalize",
  "version": "1.75.1",
  "type": "module",
  "private": true,
  "config": {
    "guard": true,
    "inline": true,
    "priority": 1
  },
  "main": "./dist/index.js",
  "module": "./src/index.js",
  "exports": {
    ".": "./src/index.js",
    "./package.json": "./package.json"
  },
  "scripts": {},
  "dependencies": {
    "@apfelkiste/client.info": "*",
    "@apfelkiste/device": "*",
    "@apfelkiste/serviceworker": "*",
    "@apfelkiste/sink": "*",
    "@homer.core/application": "*",
    "@homer.core/attribution": "*",
    "@homer.core/demand": "*",
    "@homer.core/email": "*",
    "@homer.core/entry": "*",
    "@homer.core/factory": "*",
    "@homer.core/globals": "*",
    "@homer.core/module": "*",
    "@homer.core/observer.intersection": "*",
    "@homer.core/observer.removal": "*",
    "@homer.core/observer.selector": "*",
    "@homer.core/page": "*",
    "@homer.core/phone": "*",
    "@homer.core/scheduler": "*",
    "@homer.core/script": "*",
    "@homer.core/storage.cookie": "*",
    "@homer.core/user": "*",
    "@homer.core/when.images": "*",
    "@homer.utility/itemtype.resolve": "*",
    "@homer.utility/object.filter.undefined": "*",
    "@shared/reset": "*",
    "@unifold/core": "*"
  },
  "devDependencies": {},
  "requires": [],
  "loads": [
    "?@apfelkiste/connector.gtag",
    "?@apfelkiste/connector.remarketing",
    "?@apfelkiste/connector.rtbhouse",
    "@apfelkiste/auth",
    "@apfelkiste/connector.sink",
    "@apfelkiste/errorhandler",
    "@apfelkiste/subscription.newsletter",
    "@apfelkiste/user",
    "@debug/${item}",
    "@homer.core/client.state",
    "@schema/webpageelement.dialog.followup",
    "@unifold/core",
    "@unifold/event.engagement"
  ]
}
